import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import EventMessageGroup from './event_message_group';
import Loader from '../loader';
import ModalConfirm from '../modal/modal_confirm';
// import { runInThisContext } from "vm";

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    eventId: PropTypes.number,
    isCompany: PropTypes.bool,
  },
  getInitialState() {
    return {
      loading: true,
      data: {
        myEvents: [],
        hasUnreadMessage: {},
        pagenationSettings: {
          currentPage: 0,
          maxPerPage: 0,
          isLastPage: false,
        },
        appInstallUrl: '',
      },
      modalConfirmRef: React.createRef(),
    };
  },
  loadEventMessageGroupListFromServer() {
    var companyId =
      typeof this.props.companyId === 'undefined' ? null : this.props.companyId;
    $.ajax({
      url: '/api/message/my_event_list',
      data: {
        company_id: companyId,
      },
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({
          loading: false,
          data: data,
        });
      }.bind(this),
      error: function () {}.bind(this),
    });
  },
  loadMoreEventMessageGroupListFromServer(page) {
    var companyId =
      typeof this.props.companyId === 'undefined' ? null : this.props.companyId;
    $.ajax({
      url: '/api/message/my_event_list',
      data: {
        company_id: companyId,
        page: page + 1,
      },
      dataType: 'json',
      cache: false,
      success: function (data) {
        let newData = this.state.data;
        const currentEventIds = this.state.data.myEvents.map(
          (event) => event.id
        );
        newData.myEvents = newData.myEvents.concat(
          data.myEvents.filter((event) => !currentEventIds.includes(event.id))
        );
        newData.pagenationSettings = data.pagenationSettings;
        this.setState({
          loading: false,
          data: newData,
        });
      }.bind(this),
      error: function () {}.bind(this),
    });
  },
  componentDidMount() {
    this.loadEventMessageGroupListFromServer();
    // $(window).on('focus', function() {
    //     this.loadEventMessageGroupListFromServer();
    // }.bind(this));
    setInterval(this.loadEventMessageGroupListFromServer, 13000);
  },
  render() {
    var lastEvent =
      this.state.data.myEvents[this.state.data.myEvents.length - 1];
    const isLastPage = this.state.data.pagenationSettings.isLastPage;
    var eventMessageGroup = this.state.data.myEvents.map(
      function (event) {
        return (
          <EventMessageGroup
            event={event}
            currentEventId={this.props.eventId}
            hasUnreadMessage={false}
            key={event.id}
            isCompany={this.props.isCompany}
            isLast={lastEvent == event}
            unreadMessageCount={this.state.data.unreadMessageCount[event.id]}
            lastMessage={this.state.data.lastMessages[event.id]}
            companyId={this.props.companyId}
          />
        );
      }.bind(this)
    );
    let eventMessageGroupList = (
      <div
        className="block-member "
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <span className="txt-member my-3">
          参加イベントがありません
        </span>
      </div>
    );
    const appLinkButton = isLastPage ? (
      ''
    ) : (
      <li
        onClick={() =>
          this.loadMoreEventMessageGroupListFromServer(
            this.state.data.pagenationSettings.currentPage
          )
        }
        className="hov--default"
      >
        <div className="row justify-content-around align-items-center pt-3 pb-3 border-top">
          もっとみる
        </div>
      </li>
    );
    if (this.state.data.myEvents.length !== 0) {
      eventMessageGroupList = (
        <ul className="list-unstyled mb-0">
          {eventMessageGroup}
          {appLinkButton}
        </ul>
      );
    }
    return (
      <div className="bg-white h-100 mb-2">
        <div className="container col-md-8 col-lg-6 h-100">
          <Loader isActive={this.state.loading} />
          {eventMessageGroupList}
        </div>
      </div>
    );
  },
});
